<template>
    <div class="document">
		<div class="doc-author">
			<span v-if="author">作者：{{author}}</span>
			<span v-else class="doc-author-error">该文档作者未维护</span>
		</div>
        <link-document :value="markdownText">
            <div slot="s1">
                si slot
            </div>
        </link-document>
    </div>
</template>

<script>
    export default {
        name: "document",
        inject: ['DocumentPage'],
        data() {
            const id = !this.pageParam || !this.pageParam.id ? this.pageTabData.id : this.pageParam.id
		  	const author = this.DocumentPage.idMaps[id].author
            return {
                id,
			  	author,
                markdownText: null,
            }
        },
        async created() {
            if (!this.id) return
            this.markdownText = await this.DocumentPage.getMarkdown(this.id)
          	// 统计文档打开情况
          	this.$lv.$documentAccessService.openDocEvent(this.DocumentPage.idMaps[this.id], {title: this.DocumentPage.title, op: 'open'})
        },
    }
</script>

<style lang="scss">
    .document {
        padding: 0 !important;
    }
	.doc-author {
		position: fixed;
		font-size: 12px;
		background: #fff;
		z-index: 1000;
		color: #595959;
		.doc-author-error{
			color: #ff0000;
		}
	}
</style>
